/**
 * Shared constants + tiny form helpers for the Inventory feature.
 */
export const CATEGORIES = [
  "Electrónica",
  "Ropa",
  "Hogar",
  "Vehículos",
  "Coleccionables",
  "Herramientas",
  "Deportes",
  "Juguetes",
  "Otro",
];


export const CONDICIONES = ["nuevo", "seminuevo", "usado", "reparación"];


export const empty = {
  nombre: "",
  categoria: "Otro",
  descripcion: "",
  costo: 0,
  precio_venta: 0,
  cantidad: 1,
  condicion: "usado",
  auto_publish: false,
  especificaciones: "",
};


export function Field({ label, children, full }) {
  return (
    <div className={full ? "md:col-span-2" : ""}>
      <label className="overline block mb-1.5">{label}</label>
      {children}
    </div>
  );
}
